<div class="overlay {{lock? 'hidden':''}}">
  <div class="receipt open">
    <i class="armx-icon armx-cancel close-receipt" (click)="closeRecepit()"></i>
    <div class="col-md-12">
      <receipt-table [shippments]="shippment"
                      [shipmentsByCurrency]="shipmentsByCurrency"
                     (newShippmentRequest)="onNewShippmentRequest($event)"
                     (checkout)="onCheckOut($event)"
                     (deleteShipment)="onDeleteShipment($event)"
                     (changeDiscount)="onChangeDiscount($event)"
                     (duplicateShipment)="onDuplicateShipment($event)"
                     *ngIf="showShipmentTable">
   {{shippments}}
      </receipt-table>
      <receipt-scanner *ngIf="showScanner"
                       (scannerObject)="onScannerObj($event)"
                       [scanners]="scanners"
                       [shipments]="shippment"
                       [hasInboundShipment]="hasInboundShipment"
                       [hasOutboundShipment]="hasOutboundShipment"
                       [hasDropOffShipment]="hasDropOffShipment"
                       [hasMiscShipment]="hasMiscShipment"
                       [OutboundIDScanRequired]="OutboundIDScanRequired"
                       [hasPackagingShipment]="hasPackagingShipment"
                       [PODIDScanRequired]="PODIDScanRequired"
                       [PODSignatureRequired]="PODSignatureRequired"
                       (previousTrigger)="onScannerPrevious($event)"
                       (consigneeObject)="onConsigneeObj($event)">
      </receipt-scanner>




      
      <receipt-payment *ngIf="showPaymentType"
                       [shippments]="shippment"
                       [shipmentsByCurrency]="shipmentsByCurrency"
                       [hasInboundShipment]="hasInboundShipment"
                       [hasOutboundShipment]="hasOutboundShipment"
                       [hasPackagingShipment]="hasPackagingShipment"
                       [consigneeObject]="consigneeObject"
                       [files]="files"
                       (previousTrigger)="onPaymentPrevious($event)">
      </receipt-payment>
    </div>
  </div>
</div>
